import mutations from './mutations'
import actions from './actions'
import getters from './getters'


export default {
  namespaced: true,
  state: {
    selections: []
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Adm/CPD/store/index.js